import React from "react";
import styled from "styled-components";
import { CTag, CText } from "@carrefour/design-system-components-react";
import {
  AlertStatus,
  formatDateTimeToFr,
  getStatusStyles,
} from "../../utils/alertUtils";

type AlertCardDetailProps = {
  status: AlertStatus;
  title: string;
  text: string;
  startDate: string;
  endDate?: string;
  deadlineDate?: string;
  impactFinancier?: number;
  nbActions: number;
};

const AlertCardDetailContainer = styled.div<{ status: AlertStatus }>`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 16px;
  background-color: ${props => getStatusStyles(props.status).background};
  border-radius: 10px;
`;

const CTextCustom = styled(CText)<{ color?: string; fontSize?: string, flex?: number }>`
  color: ${(props) => props.color} !important;
  font-size: ${(props) => props.fontSize || "1.2rem"} !important;
  display: inline;
  text-align: left;
  flex: ${(props) => props.flex || "0"};
`;

const AlertCardDetailDescription = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CTagCustom = styled(CTag)<{ color?: string, alignSelf?: string }>`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  color: ${(props) => props.color} !important;
  border: 1px solid  ${(props) => props.color} !important;
  align-self: ${(props) => props.alignSelf || "center"};
  p {
    color: ${(props) => props.color} !important;
    margin-left: 0;
    font-size: 0.75rem;
    font-weight: bold;
  }
`;

const AlertCardDetail: React.FC<AlertCardDetailProps> = ({
  status,
  title,
  text,
  startDate,
  endDate,
  deadlineDate,
  impactFinancier,
  nbActions,
}) => {
  const statusStyles = getStatusStyles(status);

  return (
    <AlertCardDetailContainer status={status}>
      <AlertCardDetailDescription>
        <CTextCustom fontSize=".9rem" bold={true} color={statusStyles?.color} flex={1}>
          {title}
        </CTextCustom>
        <CTagCustom size="s" icon={statusStyles?.icon} status={statusStyles?.status} color={statusStyles.color} alignSelf="flex-start">
          {statusStyles.title}
        </CTagCustom>
      </AlertCardDetailDescription>
        <CTextCustom
          color="#454545"
          tag="caption"
          size="s"
          bold={true}
          fontSize=".8rem"
        >
          {text}
        </CTextCustom>
      
      {status === AlertStatus.NEW || status === AlertStatus.IGNORED ? (
          <CTextCustom fontSize=".8rem">
            <div>
              <span style={{ fontWeight: "bold", fontSize: ".8rem" }}>
               {"Date d'apparition " + formatDateTimeToFr(startDate)}
              </span>
            </div>
            Impact financier à date: {" "}
              <span style={{ fontWeight: "bold", fontSize: ".8rem" }}>
                {impactFinancier && impactFinancier > 0 ? (impactFinancier! / 1000).toFixed(1) + " K€" : "Non chiffré"}
              </span>
          </CTextCustom>
      ) : (
        <>
          <CTextCustom size="s" fontSize=".8rem">
            <div>
              Fin du plan d'action:{" "}
              <span style={{ fontWeight: "bold", fontSize: ".8rem" }}>
                {status === AlertStatus.RESOLVED ? formatDateTimeToFr(startDate) + " - " + formatDateTimeToFr(endDate) : (deadlineDate ? formatDateTimeToFr(deadlineDate) : "-")}
              </span>
            </div>
            Nombre d'action:{" "}
            {nbActions === 0 ? (
              <span style={{ fontWeight: "bold", fontSize: ".8rem" }}>
                Aucune action
              </span>
            ) : (
              <span style={{ fontWeight: "bold", fontSize: ".8rem" }}>
                {nbActions}
              </span>
            )}
          </CTextCustom>
        </>
      )}
    </AlertCardDetailContainer>
  );
};

export default AlertCardDetail;
